import {
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalTitle,
} from '@ace-clublabs/shared-component-library';
import { sources } from '../../api/sources';
import { setGlobalState, useGlobalState } from '../../state/state';
import { Pages, SESSION_EXPIRED_STATUS_CODES } from '../../utils/constants';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { ScheduledPaymentType } from '@ace-clublabs/common-membership-api-types';
import { getMembershipNumber8 } from '@lib/shared';

export interface IScheduledPaymentWarningModalProps {
  onClose: () => void;
  visible: boolean;
}

export const ScheduledPaymentWarningModal = ({ onClose, visible }: IScheduledPaymentWarningModalProps) => {
  const [memberDetails] = useGlobalState('memberDetails');
  const { clubCode, membershipNumber } = memberDetails;
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();

  const cancelOnClick = async () => {
    setIsLoading(true);

    const membershipNumber8 = getMembershipNumber8(membershipNumber!);

    const cancelScheduledPaymentResponse = await sources.cancelScheduledPayment({
      clubCode: clubCode!,
      membershipNumber: membershipNumber8!,
      scheduledPaymentType: ScheduledPaymentType.CancelScheduledPayment,
    });

    const { status } = cancelScheduledPaymentResponse;
    const success = status === 'success';
    const error = status === 'error';

    if (success) {
      setGlobalState('paymentInfo', (prev) => ({
        ...prev,
        scheduledPaymentData: 'No active scheduled payment found',
      }));
      setIsLoading(false);
      onClose();
      return;
    } else if (error) {
      // @ts-ignore
      const timeoutError = SESSION_EXPIRED_STATUS_CODES.includes(cancelScheduledPaymentResponse?.error?.code);
      if (timeoutError) {
        history.push(Pages.TimeoutError);
      } else {
        history.push(Pages.SorryPage);
      }
    }
  };

  return (
    <Modal id="scheduled-payment-warning-modal" open={visible} size="small" onClose={onClose}>
      <ModalTitle id="scheduled-payment-warning-title" sx={{ marginRight: '1.5rem', lineHeight: '1.25rem' }}>
        Are you sure you want to cancel your scheduled payment?
        <ModalCloseIconButton
          aria-label="Close"
          id="modalCloseButton"
          onClick={() => {
            onClose();
          }}
        />
      </ModalTitle>
      <ModalActions
        actionLayout={{
          xs: 'shared',
          sm: 'shared',
          md: 'shared',
          lg: 'shared',
          xl: 'shared',
        }}
      >
        <ModalActionButton
          id="cancel-payment-confirm-no"
          className="modalActionButton"
          label={'No'}
          onClick={onClose}
          variant="outlined"
          fullWidth
        />
        <ModalActionButton
          id="cancel-payment-confirm-yes"
          label={'Yes'}
          onClick={cancelOnClick}
          variant="contained"
          fullWidth
          className={`
            ${isLoading ? 'loading' : ''}  modalActionButton`}
          loading={isLoading}
          sx={{ '&.loading': { backgroundColor: '#1c4da6 !important', borderColor: '#1c4da6 !important' } }}
        />
      </ModalActions>
    </Modal>
  );
};
